import React from "react";
import styled from "styled-components";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Spinner, { Rotating } from "./Spinner";

const Container = styled.div<{ color?: string; textColor?: string }>`
    position: relative;
    padding: 0.7em 1em;
    border-radius: 0.75em;
    background: ${(props) => props.color ?? "#ec454f"};
    color: ${(props) => props.textColor ?? "white"};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    z-index: 30;
`;

const Close = styled.span`
    position: absolute;
    right: 0;
    top: 0;
    padding: 0.25em 0.4em;
    opacity: 0.65;
    text-decoration: underline;
    cursor: pointer;
`;

type AlertProps = {
    style?: React.CSSProperties;
    icon?: IconDefinition;
    children?: React.ReactNode;
    color?: string;
    rotate?: boolean;
    textColor?: string;
    onDismiss?: () => void;
};

export default function Alert(props: AlertProps) {
    return (
        <Container textColor={props.textColor} color={props.color} style={props.style}>
            {props.icon && (
                <div style={{ margin: "0 0.6em 0 0", fontSize: "2em" }}>
                    {props.rotate ? (
                        <Rotating>
                            <FontAwesomeIcon icon={props.icon} />
                        </Rotating>
                    ) : (
                        <FontAwesomeIcon icon={props.icon} />
                    )}
                </div>
            )}
            {props.children}
            {props.onDismiss && (
                <Close onClick={props.onDismiss}>
                    <FontAwesomeIcon icon={faTimes} />
                </Close>
            )}
        </Container>
    );
}
